import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import Help from '@/components/renewal/common/help.vue';
import { useStore } from '@/store/useStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'date-option',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var store = useStore();
    var publishedOnOrAfter = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.filter.publishedOnOrAfterYear;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            publishedOnOrAfterYear: newVal
          })
        }));
      }
    });
    var isPublishedOnOrAfterValid = computed(function () {
      return publishedOnOrAfter.value === undefined || publishedOnOrAfter.value === '' || Number.isInteger(publishedOnOrAfter.value);
    });
    expose({
      isPublishedOnOrAfterValid: isPublishedOnOrAfterValid
    });
    return {
      __sfc: true,
      store: store,
      publishedOnOrAfter: publishedOnOrAfter,
      isPublishedOnOrAfterValid: isPublishedOnOrAfterValid,
      Help: Help
    };
  }
});